<template>
  <div id="contenedor-auditorias-tool-bar-tab" class="pb-4">
    <v-toolbar flat dense>
      <div style="width: 150px" class="mr-2">
        <ejercicio-picker
        v-model="filtros.ejercicio"
        class="mr-2"
        sinPeriodo>
        </ejercicio-picker>
      </div>
      <div>
        <custom-select
        v-model="filtros.enteFiscalizador"
        label="Ente Fiscalizador"
        item-value="id"
        item-text="descripcion"
        clearable
        :items="getEntesFiscalizadores">
        </custom-select>
      </div>
      <div style="width: 350px" class="mr-2">
        <custom-text-field
          label="Buscar..."
          append-icon="mdi-magnify"
          clearable
          @keyup="buscar"
          @click:clear="limpiarBuscadorTexto"
        >
        </custom-text-field>
      </div>
      <v-spacer></v-spacer>
      <v-btn
        v-if="mixValidaScopesActions(1)"
        color="primary"
        rounded
        @click="mostrarAgregarAuditoria = !mostrarAgregarAuditoria">
        <v-icon left small>
          mdi-plus
        </v-icon>
        Nueva
      </v-btn>
    </v-toolbar>
      <!-- Ventana Agregar Auditoria -->
      <v-dialog
        v-if="mostrarAgregarAuditoria"
        v-model="mostrarAgregarAuditoria"
        width="600"
        persistent>
        <NuevaAuditoria
        v-on:cerrar="mostrarAgregarAuditoria=!mostrarAgregarAuditoria"/>
      </v-dialog>
    </div>
</template>

<script>
import ENTES_FISCALIZADORES from '@/graphql/querys/administracion/catalogos/entesfiscalizadores/entesFiscalizadores.gql';
import NuevaAuditoria from '@/components/administracion/auditorias/auditoria/Nueva.vue';
import EjercicioPicker from '@/components/inputs/EjercicioPicker.vue';
import CustomTextField from '@/components/inputs/sinColumnas/TextField.vue';
import CustomSelect from '@/components/inputs/Select.vue';

export default {
  name: 'AuditoriasToolBarTab',
  props: {
    filtros: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      mostrarAgregarAuditoria: false,
      mostrarAgregarEnteFiscalizador: false,
      debounce: null,
    };
  },
  apollo: {
    entesFiscalizadores: {
      query: ENTES_FISCALIZADORES,
    },
  },
  components: {
    EjercicioPicker,
    CustomTextField,
    CustomSelect,
    NuevaAuditoria,
  },
  computed: {
    getEntesFiscalizadores() {
      if (!this.entesFiscalizadores) return [];
      return this.entesFiscalizadores;
    },
  },
  methods: {
    buscar(e) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.filtros.buscarTexto = e.target.value;
      }, 600);
    },
    limpiarBuscadorTexto() {
      this.filtros.buscarTexto = '';
    },
  },
};
</script>

<style lang="scss">

</style>
